import './index.css';

const AccordionEs = () => {
    return (
        <>
            <ul className="accordion-ul">
                <li className="accordion-li">
                    <input type="checkbox" defaultChecked={true} />
                    <i className="mg-top-arrow"></i>
                    <h2 className="accordion-title">Aparteno</h2>
                    <p>
                        La bezono aparteni al familio, grupo, generacio, kvartalo... estas natura bezono konata al ĉiuj.
                        Sed „aparteno“ estas ankaŭ rajto. Se ies rajto aparteni estas malobservita, la familia
                        „konscienco“ per sistemaj influoj prizorgas ke ĉiu akiru sian apartenon.
                    </p>
                    <p>
                        Se iu estas ekskludita, se al iu rajto aparteni estas forprenita per malapero, forpelo,
                        prihonto, malakcepto aŭ ne plena akcepto, la familia konscienco trovas manieron doni al tiuj
                        membroj la rajton aparteni per influado al la vivo de aliaj familianoj, kaj tiamaniere
                        transgeneracie transdoni informon pri tiu ekskludita membro al nova generacio. Ekskludo influas
                        ne nur se la persono estas ekskludita, sed ankaŭ se grandaj kaj gravaj emocioj estas
                        subpremataj, eventoj neitaj, sekretoj kaŝitaj... Per la familia konscienco ĉiu ekskludo trovas
                        manieron montriĝi tra familiano aŭ per evento.
                    </p>
                    <p>
                        Kaj kiu membroj rajtas kaj apartenas al la familio?
                        <ul>
                            <li>Partneroj, nunaj kaj iamaj</li>
                            <li>Gefratoj</li>
                            <li>Patrino kaj patro</li>
                            <li>
                                Fratoj kaj fratinoj de patro kaj patrino (onkloj kaj onkloj, sed ne iliaj partneroj kaj
                                infanoj)
                            </li>
                            <li>Geavoj kaj iliaj gefratoj</li>
                            <li>Kaj tiel plu...</li>
                        </ul>
                    </p>
                    <p>
                        Krome, al familioj apartenas ankaŭ ĉiuj, kiuj grave influis al la sorto de la familio, kiuj
                        subtenis aŭ savis vivojn:
                        <ul>
                            <li>adoptitaj gepatroj</li>
                            <li>personoj kiuj grave helpis kaj subtenis la familion age, materiale kaj spirite</li>
                        </ul>
                    </p>

                    <p>
                        Sed ankaŭ tiuj, kiuj forprenis vivon: viktimoj kaj viktigantoj apartenas kaj al la familio de la
                        viktimo kaj al la familio de la viktiganto. Oni devas agnoski ilian ekziston kaj rekoni ilian
                        influon al la ambaŭ familioj.
                    </p>
                    <p>
                        Grava influo al la familio venas de familianoj kiuj „mankas“:
                        <ul>
                            <li>familianoj kiuj mortis tro frue</li>
                            <li>familianoj kiuj elmigris aŭ forlasis la familion</li>
                            <li>familianoj kiuj estas neitaj aŭ kaŝitaj pro ia honto</li>
                            <li>nenaskitaj infanoj</li>
                            <li>ekstergeedzaj infanoj</li>
                            <li>mense aŭ korpe handikapitaj</li>
                            <li>fraŭlaj partneroj</li>
                            <li>signifaj antaŭaj partneroj de gepatroj</li>
                            <li>homoj kiuj iel embarasis la familion kaj la familio hontas pri ili</li>
                            <li>viktimoj kaj krimintoj...</li>
                        </ul>
                    </p>
                    <p>
                        Al la fa familio ankaŭ apartenas subpremitaj emocioj ligitaj al signifaj okazaĵoj kiel milito,
                        malsato, malriĉeco, ŝtelo aŭ nemeritita akiro de posedaĵo, forlaso de naskloko kaj movigado al
                        novaj loĝlokoj kaj al novaj kulturaj komunumoj.
                    </p>
                    <p>
                        Kiel la familia konscienco certigas, ke ĉiuj kaj ĉio apartenas? Unu el la manieroj estas, ke
                        similaj aŭ samaj eventoj ripetiĝas en la familio tra pluraj generacioj. Aŭ en tiaj familioj
                        aperas inklino al similaj malsanoj, inkluzive mensajn malordojn. Aŭ iu pli juna viro en la
                        familio "prenas" la karakteron de ekskludita onklo kiun li neniam renkontis, aŭ membro de
                        familio sentas alies kulpon, honton, koleron, maljustecon aŭ simile, kiu „devenas“ de familia
                        kaŝita pasinteco .
                    </p>
                    <p>
                        Same, portante subpremitajn emociojn kaj vivŝarĝojn de niaj gepatroj aŭ pragepatroj aŭ ne
                        akceptante kaj prijuĝante ilin, rezulte, ni estas kvazaŭ devigitaj parte ripeti iliajn sortojn.
                    </p>
                </li>
                <li className="accordion-li">
                    <input type="checkbox" defaultChecked={true} />
                    <i className="mg-top-arrow"></i>
                    <h2 className="accordion-title">Ordo</h2>
                    <p>
                        Ordo aŭ ordigo en la familio certigas, ke la fluo de la vivo fluas plenforte kaj atingas ĉiujn
                        familianojn. Kiam ĉi tiu ordo estas perturbita, la fluo de vivenergio malfortiĝas kaj la kapablo
                        ricevi kaj doni estas difektita. Kaj en la familio kiel tuto kaj ĉe individuaj membroj.
                    </p>
                    <p>
                        La baza regulo de ordo estas, ke vivenergio fluas plej abunde kaj direkte de la pli maljuna al
                        la pli juna, do tiuj kiuj alvenas unue - donas kaj tiuj kiuj alvenas poste - ricevas.
                        <br />
                        Alia grava regulo estas, ke la nova familio havas prioritaton super la fonto-familio. kiel diras
                        la Biblio: „Tial viro forlasos sian patron kaj sian patrinon, kaj aliĝos al sia edzino, kaj ili
                        estos unu karno.“
                    </p>
                    <p>
                        Krome, ĉiu en la familio havas sian lokon kaj rolon asociitan kun tiu loko. Gefiloj laŭ la ordo
                        de nasko, ..La plej facile kaj fruktodone estas vivi sian vivon laŭ la rolo de sia loko.Kaj ĉiuj
                        kiuj apartenas havas sian rolon kaj sian lokon. Estas tute nature, ke foje la ordo en la familio
                        estas provizore interrompita, post gravaj personaj malfortoj aŭ traŭmatoj, fruaj mortoj aŭ
                        partnereco-rompoj.
                    </p>
                    <p>
                        En ĉi tiuj kazoj, iu el la familio provizore prenas la rolon kaj "lokon" de la membro, kiu ne
                        plu estas aŭ kiu estas malforta. Kiel provizora helpo, ĝis la familio aŭ familiano refortiĝu.
                        Sed post refortiĝo gravas, ke ĉiu denove prenu sian rolon. Ne estas bone, ke provizora helpo
                        restu konstanta. Infanoj estas precipe inklinaj al tio kaj eĉ kiam ili plenkreskas, ili daŭrigas
                        vivi alies vivon kaj destinon kaj mistrafas plene vivi sian.
                    </p>
                    <p>
                        Ofta perturbo en la ordo ankaŭ estas „gepatrigado“, kiam infanoj prenas la rolon de "gepatroj"
                        al sia patro aŭ al patrino aŭ al ambaŭ.
                        <br /> Tio montriĝas per prijuĝo aŭ kritikado de gepatroj. Opinio ke ili pli bone vivus la vivon
                        de iliaj gepatroj, farus pli saĝajn decidojn, estus pli ĝentila kaj donema, pli „patra“ aŭ
                        „patrineca“, pli kuragxa…
                        <br /> Konstante prijuĝas kaj plendas pri siaj gepatroj kaj iliajn gepatrajn kapablojn, samtempe
                        havante tre malbonajn rilatojn kun ili, daŭre postulante atenton de siaj gepatroj. En la kazo de
                        ne plu funkcianta partnereco, la filo aŭ filino provas helpi parte prenante patran aŭ patrinan
                        lokon en la familio kaj iom post iom iĝas "la filoj de panjo" kaj "la filinoj de paĉjo". Filo aŭ
                        filino kaptita en roloj al kiu ne apartenas, ne vivas plene sian propran vivon. Eĉ se ili
                        sukcesas realigi propran partnerecon, tiu partnereco estos ŝarĝita per devoj al la origina
                        familio, tiel ke nova partnereco iĝas malfunkcia... kaj la procezo ripetiĝas.
                    </p>
                    <p>
                        Eliri el la malĝusta rolo estas en kelkaj paŝoj:
                        <ul>
                            <li>konsciiĝu pri via &quot;malĝusta&quot; loko,</li>
                            <li>
                                akceptu kaj respektu la familianon, kiun vi provas &quot;anstataŭigi&quot; – tia kia
                                li/ŝi estas
                            </li>
                            <li> prenu respondecon por vi mem kaj nur vi mem.</li>
                            <li> respektu aliajn, ilian sorton kaj vivojn kaj ĉesu &quot;helpi&quot; ilin</li>
                        </ul>
                    </p>
                </li>
                <li className="accordion-li">
                    <input type="checkbox" defaultChecked={true} />
                    <i></i>
                    <h2 className="accordion-title">Ekvilibro de donado kaj ricevado</h2>
                    <p>
                        Kvankam ĉi tiu principo ne estas konsiderata baza principo de konstelacioj, tiu ĉi regulo havas
                        sian aplikon kaj estas interplektita kun la bazaj principoj de aparteno kaj ordo.
                    </p>
                    <p>
                        En ĉio, kio okazas en niaj vivoj, gravas havi ekvilibron de donado kaj ricevado.
                        <ul>
                            <li>
                                Familiano „donas“ lojalecon, akcepton de reguloj kaj roloj en la familio. Samtempe
                                ricevas senton de aparteno, senton de kaj sekureco kaj libereco ene de sia familio.
                            </li>
                            <li>
                                Gepatroj donas vivon, infanoj plu transdonas vivon laŭ sia maniero. Ekzistas nenia ŝuldo
                                de infanoj al gepatroj!!
                            </li>
                            <li>
                                Gepatroj kompletigas sian rolon donante al siaj infanoj plenan fidon, kaj infanoj
                                plenkreskas kiam ili evoluigas respekton por siaj gepatroj kaj transprenas respondecon
                                pri sia vivo kaj destino. Kiam plenkreskaj infanoj ne sekvas ĉi tiun regulon, la kapablo
                                „ricevi“ estas reduktita en pluraj vivaspektoj.
                            </li>
                            <li>
                                Gepatroj subkonscie sentas kiam iliaj infanoj plenkreskiĝas kaj tiam ĉesas esti "ĝenaj"
                                al ili. Ĝis tiam, ili instinkte spegulas la malsekurecon kaj nematurecon de siaj
                                infanoj.
                            </li>
                            <li>
                                Ekvilibro en donado kaj ricevado en partnereco NE ekzistas!! Kiam partnero donas, la
                                alia partnero redonas sed iom pli ol tio, kion li/ŝi ricevis. Kaj tiel kreskas la amo.
                            </li>
                            <li>
                                Kiam partnero dolorigas, la alia partnero havas la rajton redoni doloron, sed en pli
                                malgranda mezuro. Tiel neniu estas viktimo kaj la rilato estas konservita.
                            </li>
                            <li>
                                Pardono ne alportas repaciĝon. Ĝi kreas eternan ŝuldon al tiu al kiu vi pardonas: "Mi
                                estas pli bona ol vi kaj mi pardonas vin.Vi ŝuldas al mi por ĉiam."
                            </li>
                            <li>
                                Kiam vi vundas iun, vi ne petu pardonon. Vi tiel egoisme volas nur liberigi vin de via
                                sento de kulpo . Kiam iu estas en doloro, ne helpas devigi lin/ŝin zorgi pri via
                                bedaŭro.
                            </li>
                            <li>
                                Kiam vi dolorigis iun, gravas ke vi agnosku la doloron kiun vi kaŭzis Agnoski unue al vi
                                mem, sen pravigoj kaj klarigoj. Agnosku! Agnosku doloron al la persono kiun vi vundis
                                NUR KIAM LI/ŜI ESTAS PRETA. Prenante vian parton de respondeco, vi liberigas tiun, kiun
                                vi vundis.
                            </li>
                            <li>
                                Kiam vi ricevas ion vi{' '}
                                <ul>
                                    <li className="third-layer">aŭ redonu la saman mezuron al tiu de kiu vi ricevis</li>
                                    <li className="third-layer">aŭ plusendu al iu alia</li>
                                    <li className="third-layer">
                                        aŭ ekvilibru per sincera danko, por ke ne estu ŝuldo.
                                    </li>
                                </ul>
                            </li>
                            <li>Kiam vi donas, vi donu nur senkondiĉe. Ĉio alia estas komerco aŭ ŝuldigo</li>
                            <li>
                                Kiam io estas donata, ne necesas ricevi ĝin reen aŭ redoni ĝin al tiu de kiu ĝi estis
                                ricevita kaj en la sama maniero. Ekzemple, la instruisto donas scion kaj lernanto
                                redonas respekton.
                            </li>
                        </ul>
                    </p>
                </li>
            </ul>
        </>
    );
};

export default AccordionEs;
